import { useEffect, useRef, useState } from "react";
import "../styles/grainCarousel.css";

const grains = [
    { name: "Moong Dal", img: "/images/moong.jpg" },
    { name: "Masoor Dal", img: "/images/masoor.jpg" },
    { name: "Toor Dal", img: "/images/moong-yellow.jpg" },
    { name: "Urad Dal", img: "/images/urad.jpg" },
    { name: "Kali Urad Dal", img: "/images/kali-urad-daal.jpeg" },
];

export default function GrainCarousel() {
    const trackRef = useRef(null);
    const [index, setIndex] = useState(0);
    const [isTransitionEnabled, setIsTransitionEnabled] = useState(true);

    const visibleCount = 3;
    const itemWidth = 280; // card + gap
    const totalItems = grains.length;

    useEffect(() => {
        const interval = setInterval(() => {
            setIndex((prev) => prev + 1);
        }, 2500); // slide delay

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        const track = trackRef.current;
        if (!track) return;

        // Calculate actual translation
        const translateX = index * itemWidth;
        
        // Apply transition if enabled
        if (isTransitionEnabled) {
            track.style.transition = "transform 0.6s ease";
        } else {
            track.style.transition = "none";
            setIsTransitionEnabled(true); // Re-enable for next animation
        }
        
        track.style.transform = `translate3d(-${translateX}px, 0, 0)`;

        // Check if we need to reset (when we've shown all original items + 1)
        if (index >= totalItems) {
            // After animation completes, instantly reset
            const resetTimeout = setTimeout(() => {
                setIsTransitionEnabled(false);
                setIndex(0);
            }, 600); // Match transition duration
            
            return () => clearTimeout(resetTimeout);
        }
    }, [index, isTransitionEnabled, totalItems]);

    // Duplicate items for seamless loop
    const duplicated = [...grains, ...grains.slice(0, visibleCount)];

    return (
        <section className="grain-carousel-section">
            <h2 className="grain-carousel-title section-heading">Grains & Pulses</h2>

            <div className="grain-scroll-container">
                <div className="grain-scroll" ref={trackRef}>
                    {duplicated.map((grain, i) => (
                        <div className="grain-card" key={i}>
                            <div className="grain-circle-container">
                                <div className="grain-circle">
                                    <img src={grain.img} alt={grain.name} className="grain-image" />
                                </div>
                                <div className="grain-ribbon">{grain.name}</div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}